import OfflinePageShow from "./Offline_icon";
export default OfflinePageShow;